import { Extension } from "@tiptap/core";
import ImportWordButton from "../../extensions/ImportWord/components/ImportWordButton";

export const ImportWord = Extension.create({
	name: "importWord",
	addOptions() {
		return {
			...this.parent?.(),
			upload: undefined,
			convert: undefined,
			button: ({ editor, extension, t }) => {
				const { convert } = extension.options;
				return {
					component: ImportWordButton,
					componentProps: {
						convert,
						action: () => editor.commands.setHorizontalRule(),
						icon: "Word",
						shortcutKeys: ["alt", "mod", "S"],
						tooltip: t("editor.importWrod.tooltip"),
						editor
					}
				};
			}
		};
	}
});
